<template>
    <div class="wrapper-Cmodulos">
        <h3 class="mb-2">Modulo de Notificaciones</h3>
        <CMenuModulo :moduloId="enumeraciones.sinoj.modulos.Notificaciones.id"></CMenuModulo>
    </div>
</template>
<script>
import sistemas from '@/../static/js/sistemas'
import enumeraciones from '@/../static/js/enumeraciones'

export default {
    components: {
        CMenuModulo: sistemas.SINOJ.CMenuModulo,
    },
    data() {
        return {
            enumeraciones
        }
    }
}
</script>
<style scoped>
.wrapper-Cmodulos h3 {
    color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Notificaciones/CMenuNotificaciones.vue